// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Reference expression source type
 */
export enum ECpmCReferenceExpressionSourceTypeApiEnum {
    CUSTOMER = 'cus',
    LOCATION = 'loc',
    OBJECT_STORE = 'os'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCReferenceExpressionSourceTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCReferenceExpressionSourceTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCReferenceExpressionSourceTypeApiEnum
        ])
);

